module.exports = __webpack_public_path__ + "img/dashboard.17377b2d.svg";